export default "__VITE_ASSET__BWSrpv93__"